import axios from "axios";

import { SESSION_TOKEN } from "../constants/index";
import flightCancelEligibilityMock from "../tests/flightCancelEligibilityMock";

const cancelEligibility = async (recordLocator: any, apiDomain: string) => {
  const dataValue = {
    recordLocator,
  };
  const token = localStorage.getItem(SESSION_TOKEN);
  const flightCancelEligibilityUrl = `${apiDomain}${"/voebiz-checkout/v1/canceleligibility"}`;
  const vbzDebug = localStorage.getItem("vbzDebug");

  if (vbzDebug) {
    return flightCancelEligibilityMock;
  }

  return axios
    .put(flightCancelEligibilityUrl, dataValue, {
      headers: {
        memberNumber: "123",
        channel: "WEB",
        region: "VOEBIZ",
        action: "CANCEL",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};
export { cancelEligibility };
